













import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { RouteHelpers, FormFieldValidation, ModalHelpers } from '@/mixins';
import { Configuration, ArenaSignApi } from '@/types';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import ArenaSignEditTemplateAfterSignMappings from '@/components/configuration/arenaSign/ArenaSignEditTemplateAfterSignMappings.vue';

export default Vue.extend({
  name: 'ScriveEditTemplateAfterSignMappings',
  mixins: [RouteHelpers, FormFieldValidation, ModalHelpers],
  data() {
    return {
      isLoading: true,
      hasError: false,
      errorMessage: '',
      scriveTemplateAfterSignConfiguration: {},
      arenaSignApi: ArenaSignApi.Scrive
    };
  },
  methods: {
    async getData(this: any) {
      // tslint:disable-next-line:max-line-length
      this.scriveTemplateAfterSignConfiguration = await ScriveConfigurationService.getTemplateAfterSignConfigurationAsync(
        parseInt(this.$route.params.id, 10)
      );
    },
    navigateToMappingsManagement(this: any) {
      this.$router.push({ name: Configuration.Scrive.AfterSignMapping.Management.name });
    }
  },
  async mounted() {
    await this.getData();
    this.isLoading = false;
  },
  components: {
    LoadingSpinner,
    MStoreFormSelect,
    ArenaSignEditTemplateAfterSignMappings
  }
});
